import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--color-gray-07)",
      "fill-rule": "evenodd",
      d: "M2.583 9.999c0 .192.073.384.22.531l4.996 5a.75.75 0 1 0 1.061-1.06l-3.72-3.723h11.527a.75.75 0 0 0 0-1.5H5.145L8.86 5.53A.75.75 0 0 0 7.8 4.47L2.841 9.43a.75.75 0 0 0-.26.567z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }